/**
 * Get display photo URL with fallback to default avatar
 * @param {string|array} photos - Photo URL or array of photo URLs
 * @param {number} index - Index of photo to get (default 0)
 * @returns {string} Full photo URL
 */
export const getPhotoUrl = (photos, index = 0) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL;
  
  // Handle array of photos
  if (Array.isArray(photos) && photos.length > 0) {
    const photo = photos[index] || photos[0];
    if (photo.startsWith('http')) {
      return photo;
    }
    return `${API_URL}${photo}`;
  }
  
  // Handle single photo string
  if (typeof photos === 'string' && photos) {
    if (photos.startsWith('http')) {
      return photos;
    }
    return `${API_URL}${photos}`;
  }
  
  // Fallback to default avatar
  return '/default-avatar.png';
};

/**
 * Get user's primary photo with fallback
 * @param {object} user - User object with photos array
 * @returns {string} Full photo URL
 */
export const getUserPhoto = (user) => {
  return getPhotoUrl(user?.photos);
};
